export const humanConstants = {
    UPLOAD_IMAGE_HUMAN_MODEL_REQUEST: 'UPLOAD_IMAGE_HUMAN_MODEL_REQUEST',
    UPLOAD_IMAGE_HUMAN_MODEL_SUCCESS: 'UPLOAD_IMAGE_HUMAN_MODEL_SUCCESS',
    UPLOAD_IMAGE_HUMAN_MODEL_FAILURE: 'UPLOAD_IMAGE_HUMAN_MODEL_FAILURE',

    SWITCH_HUMAN_MODEL_REQUEST: 'SWITCH_HUMAN_MODEL_REQUEST',
    SWITCH_HUMAN_MODEL_SUCCESS: 'SWITCH_HUMAN_MODEL_SUCCESS',
    SWITCH_HUMAN_MODEL_FAILURE: 'SWITCH_HUMAN_MODEL_FAILURE',
};